module.exports = __webpack_public_path__ + "static/media/Checked-green.a6e8c197.png";